module.exports = __webpack_public_path__ + "static/media/sky-background.d3a300b4.png";